import * as Matter from 'matter-js';
import type { SceneDef } from './types';
import { createGround, groundTopY } from './util';

export const projectile: SceneDef = {
  labelKey: 'scene.projectile',
  defaultPlaying: false,
  params: [
    { id: 'angle', labelKey: 'dim.angleLaunch', min: 10, max: 85, step: 1, value: 45 },
    // Matter's body velocity is pixels-per-step; values above ~12 produce trajectories
    // that overshoot the canvas in a few frames. Tight range with finer resolution.
    { id: 'velocity', labelKey: 'dim.velocity', min: 1, max: 12, step: 0.5, value: 6 },
    { id: 'gravity', labelKey: 'dim.gravity', min: 0.2, max: 1.6, step: 0.1, value: 1 },
  ],
  build({ engine, world, dims, bounds }) {
    engine.gravity.y = dims.gravity!;

    const ground = createGround(bounds);

    const ballR = 12;
    const launcherX = 60;
    const launcherY = groundTopY(bounds) - 20;
    const angleRad = (dims.angle! * Math.PI) / 180;
    const ball = Matter.Bodies.circle(launcherX, launcherY, ballR, {
      restitution: 0.4,
      friction: 0.02,
    });
    Matter.Body.setVelocity(ball, {
      x: dims.velocity! * Math.cos(angleRad),
      y: -dims.velocity! * Math.sin(angleRad),
    });

    const bodies = [ground, ball];
    Matter.World.add(world, bodies);

    return {
      bodies,
      constraints: [],
      drawOverlay(ctx) {
        ctx.save();
        ctx.fillStyle = '#666';
        ctx.beginPath();
        ctx.arc(launcherX, launcherY, 4, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      },
      dispose() {
        Matter.World.remove(world, bodies);
      },
    };
  },
};
